import type { AdresseVaelgerFund } from '../components/user-input/picker/AdressPicker/AddressPicker.types';
import { fetchRequest } from './fetch';
import { ApiOptions } from './types';

export const get = (path: string, options?: ApiOptions) => {
  return fetchRequest(path, 'GET', undefined, undefined, options);
};

export const put = (data: any, path: string) => {
  return fetchRequest(path, 'PUT', data);
};

export const post = (data: any, path: string, options?: ApiOptions) => {
  return fetchRequest(path, 'POST', data, undefined, options);
};

export const deleteRequest = (path: string, data: any) => {
  return fetchRequest(path, 'DELETE', data);
};

const adresseVaelgerBaseUrl = 'https://adressevaelger.dk';
const adresseVaelgerToken = 'adressevaelger123';

export const getAdresseVaelger = async (path: string) => {
  try {
    const response = await window.fetch(`${adresseVaelgerBaseUrl}/${path}`);
    if (!response.ok) {
      return null;
    }
    return await response.json();
  } catch (e) {
    return null;
  }
};

export const searchAddresses = async (query: string) => {
  if (!query.trim()) {
    return [];
  }
  const params = new URLSearchParams({ tekst: query, token: adresseVaelgerToken });
  const response = await getAdresseVaelger(`adresser/soeg?${params.toString()}`);
  if (!response || !Array.isArray(response.fund)) {
    return [];
  }
  return response.fund as AdresseVaelgerFund[];
};

export const getAddressById = async (id: string) => {
  const params = new URLSearchParams({ token: adresseVaelgerToken });
  const response = await getAdresseVaelger(`adresser/${encodeURIComponent(id)}?${params.toString()}`);
  return response?.adresse ?? null;
};

export const getHouseNumberById = async (id: string) => {
  const params = new URLSearchParams({ token: adresseVaelgerToken });
  const response = await getAdresseVaelger(`husnumre/${encodeURIComponent(id)}?${params.toString()}`);
  return response?.husnummer ?? null;
};

export const searchHousesOnStreet = async (streetName: string, postalCode: string) => {
  if (!streetName.trim() || !postalCode.trim()) {
    return [];
  }
  const params = new URLSearchParams({ vejnavn: streetName, postnummer: postalCode, token: adresseVaelgerToken });
  const response = await getAdresseVaelger(`adresser/soeg?${params.toString()}`);
  if (!response || !Array.isArray(response.fund)) {
    return [];
  }
  return response.fund as AdresseVaelgerFund[];
};
